/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/login',
    name: 'login',
    view: 'Login'
  },
  {
    path: '/dashboard',
    name: 'ダッシュボード',
    // Relative to /src/views
    view: 'dashboard/Index'
  },
  {
    path: '/list',
    name: 'リスト作成',
    view: 'list/Index'
  },
  {
    path: '/list/print',
    name: '印刷プレビュー画面',
    view: 'list/PrintPreview'
  },
  {
    path: '/customers',
    name: '顧客',
    view: 'customers/Index'
  },
  {
    path: '/customers/detail',
    name: '顧客登録',
    view: 'customers/Register'
  },
  {
    path: '/sensors',
    name: 'センサー',
    view: 'sensors/Index'
  },
  // {
  //   path: '/companies',
  //   name: '提携企業',
  //   view: 'companies/Index'
  // },
  // {
  //   path: '/companies/:id',
  //   name: '提携企業登録',
  //   view: 'companies/Register'
  // },
  {
    path: '/groups',
    name: 'グループ',
    view: 'groups/Index'
  },
  {
    path: '/tank-types',
    name: 'タンクタイプ',
    view: 'tank-types/Index'
  },
  {
    path: '/users',
    name: 'ユーザ',
    view: 'users/Index'
  },
  // {
  //   path: '/authorities/roles',
  //   name: 'ロール',
  //   view: 'authorities/Index'
  // },
  // {
  //   path: '/authorities/role-edit',
  //   name: 'ロール編集',
  //   view: 'authorities/RoleEdit'
  // },
  // {
  //   path: '/authorities/user-edit',
  //   name: 'ユーザー管理',
  //   view: 'authorities/UserEdit'
  // },
  // {
  //   path: '/audits',
  //   name: '監査',
  //   view: 'audits/Index'
  // },
  {
    path: '/profile',
    name: '設定',
    view: 'profile/Index'
  },
  {
    path: '/release-notes',
    name: 'リリースノート',
    view: 'release-notes/Index'
  },
  {
    path: '/terms',
    name: '利用規約',
    view: 'Terms'
  }
]
